import { ref, computed, watch } from 'vue'

const STORAGE_KEYS = {
  timeRange: 'dashboard_global_timeRange',
  refreshInterval: 'dashboard_global_refreshInterval'
}

// Global reactive state (singleton pattern)
const globalTimeRange = ref(null)
const globalRefreshInterval = ref(null)

export function useGlobalDashboardSettings() {
  // Initialize from localStorage on first use
  if (globalTimeRange.value === null) {
    const stored = localStorage.getItem(STORAGE_KEYS.timeRange)
    globalTimeRange.value = stored || 'per_widget'
  }

  if (globalRefreshInterval.value === null) {
    const stored = localStorage.getItem(STORAGE_KEYS.refreshInterval)
    globalRefreshInterval.value = stored || 'per_widget'
  }

  // Computed flags
  const hasTimeRangeOverride = computed(() =>
    globalTimeRange.value !== 'per_widget'
  )

  const hasRefreshOverride = computed(() =>
    globalRefreshInterval.value !== 'per_widget'
  )

  // Persist to localStorage on change
  watch(globalTimeRange, (value) => {
    localStorage.setItem(STORAGE_KEYS.timeRange, value)
  })

  watch(globalRefreshInterval, (value) => {
    localStorage.setItem(STORAGE_KEYS.refreshInterval, value)
  })

  // Helper functions
  function setGlobalTimeRange(value) {
    globalTimeRange.value = value
  }

  function setGlobalRefreshInterval(value) {
    globalRefreshInterval.value = value
  }

  function getEffectiveTimeRange(widgetTimeRange) {
    return hasTimeRangeOverride.value
      ? globalTimeRange.value
      : widgetTimeRange
  }

  function getEffectiveRefreshInterval(widgetInterval) {
    return hasRefreshOverride.value
      ? parseInt(globalRefreshInterval.value)
      : widgetInterval
  }

  function resetAllOverrides() {
    globalTimeRange.value = 'per_widget'
    globalRefreshInterval.value = 'per_widget'
  }

  return {
    // State
    globalTimeRange,
    globalRefreshInterval,

    // Computed flags
    hasTimeRangeOverride,
    hasRefreshOverride,

    // Methods
    setGlobalTimeRange,
    setGlobalRefreshInterval,
    getEffectiveTimeRange,
    getEffectiveRefreshInterval,
    resetAllOverrides
  }
}
